<template>
  <div class="px-4 pb-4 sm:px-6 sm:pb-6">
    <h1 class="my-2">
      {{
        document.isTemplate ? t("headings.template") : t("headings.document")
      }}
    </h1>
    <breadcrumb class="mt-3 mb-4" />
    <div class="grid gap-4">
      <div v-if="!waiting" class="card p-4">
        <h3 class="mb-3">{{ document.name }}</h3>
        <read-only
          v-if="document.content"
          :content="JSON.parse(document.content)"
        />
        <hr v-if="isBoardMember(user)" class="my-3 border-gray-300" />
        <div v-if="isBoardMember(user)" class="flex justify-end">
          <form-button
            :command="() => router.push(`/documents/${document.id}/edit`)"
            :disabled="waiting"
            id="edit-button"
            label="edit"
            :textVariant="company.primaryText"
            type="submit"
            :variant="company.primary"
          />
        </div>
      </div>
      <div v-if="!waiting" class="card p-4">
        <h3 class="mb-3">{{ t("headings.attachments") }}</h3>
        <div
          v-if="!document.attachments || !document.attachments.length"
          class="py-8 text-center"
        >
          {{ t("labels.no_files") }}
        </div>
        <div
          v-else
          class="grid grid-cols-2 gap-4 py-4 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6"
        >
          <div
            v-for="(file, fileIndex) in document.attachments"
            :key="fileIndex"
            class="cursor-pointer rounded-md border border-slate-300 p-4"
            :style="{
              borderColor: fileHovers[fileIndex] ? company.primary[500] : null,
            }"
            @mouseover="fileHovers[fileIndex] = true"
            @mouseleave="fileHovers[fileIndex] = false"
          >
            <DocumentIcon
              :style="{
                color: company.primary[500],
              }"
            />
            <div class="truncate pb-2 font-bold">
              {{ file.name }}
            </div>
            <div class="flex items-center justify-end">
              <div
                class="rounded-md border border-slate-200 p-2 hover:border-slate-300"
                @click="openFile(file.path)"
              >
                <ArrowDownTrayIcon class="h-5 w-5" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  ArrowDownTrayIcon,
  DocumentArrowUpIcon,
  DocumentIcon,
  XMarkIcon,
} from "@heroicons/vue/24/outline";
import { isBoardMember } from "../utils/roleUtils";
import { computed, onMounted, ref, watch } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute, useRouter } from "vue-router";
import { useStore } from "vuex";
import Breadcrumb from "../components/breadcrumb/Breadcrumb.vue";
import ReadOnly from "../components/editor/ReadOnly.vue";
import FormButton from "../components/form/FormButton.vue";
export default {
  components: {
    ArrowDownTrayIcon,
    Breadcrumb,
    DocumentArrowUpIcon,
    DocumentIcon,
    FormButton,
    ReadOnly,
    XMarkIcon,
  },
  setup() {
    const route = useRoute();
    const router = useRouter();
    const store = useStore();
    const { t } = useI18n();

    const attachment = computed(() => store.state.file.file);
    const document = computed(() => store.state.document.document);
    const user = computed(() => store.state.authentication.user);

    const waiting = computed(() => {
      if (store.state.company.waiting) return true;
      if (store.state.document.waiting) return true;
      return false;
    });

    const fileHovers = ref([]);

    const openFile = (path) => {
      store.dispatch("file/getFile", path);
    };

    onMounted(() => {
      if (!document.value.id || document.value.id != route.params.documentId) {
        store.dispatch("document/getDocument", route.params.documentId);
      }
    });

    watch(
      () => attachment.value,
      (val) => {
        if (val) {
          window.open(val, "_blank");
        }
      }
    );

    return {
      company: computed(() => store.state.company.company),
      document,
      fileHovers,
      isBoardMember,
      openFile,
      router,
      t,
      user,
      waiting,
    };
  },
};
</script>
